import {
  ActionType,
  IInformationSettingResponse,
} from "models/setting/general";

export const getSettingInformationAction = () => {
  return {
    type: ActionType.INFORMATION_SETTING,
  };
};

export const handleErrorAction = (payload: string) => {
  return {
    type: ActionType.INFORMATION_SETTING_ERROR,
    payload,
  };
};

export const handleSuccessAction = (payload: IInformationSettingResponse) => {
  return {
    type: ActionType.INFORMATION_SETTING_SUCCESS,
    payload,
  };
};

export const handleResetAction = () => {
  return {
    type: ActionType.INFORMATION_SETTING_RESET,
  };
};
